
import React, { Component } from "react";
import Card from "components/Card/Card.jsx";
export default class BLOCK3 extends Component {
    render() {
      return <Card title="คำชี้แจง" legend={<div className="legend">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;การส่งรายงานการจัดการพลังงานประจำปี
                พ.ศ.2561 สามารถกรอกข้อมูลงในระบบ E-FORM
                เพื่อให้อาคารควบคุมและโรงงานควบคุมมีฐานข้อมูลที่ใช้สำหรับการวิเคราะห์ในอนาคตได้
                แต่การส่งรายงานลักษณะนี้ยังไม่มีผลตามกฏหมาย
                ดังนั้นอาคารควบคุมและโรงงานควบคุมยังต้องส่งเล่มรายงานฯ
                ในรูปแบบเอกสารพร้อม CD มายัง
                กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน ตามปกติภายในวันที่
                      31 มีนาคม 2562 นี้{" "}
            </div>} content={<div className="" />}>
        </Card>;
    }
}




// WEBPACK FOOTER //
// ./src/view/block/block-3.js